export default "__VITE_ASSET__Dy85Bh5J__"